import { useEffect, useState } from "react";
import { http } from "../lib/api";

let cache = null;

export function useProducts() {
  const [products, setProducts] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    http.get("/products").then((r) => { cache = r.data; setProducts(r.data); }).catch(() => {});
  }, []);
  return products;
}
